<!-- 我的报名 -->
<template>
  <div style="background-color: #F6F6F6;padding-top: 80px;background-image: linear-gradient(to bottom,#CCE7FF,35%,#f9f9f9)">
    <div class="personalCore-box">
      <div class="personalCore-left-myEnrollVue">
<!--        <div class="personalCore-left-title">我的报名</div>-->
        <div class="personalCore-left-list" style="float: left;">
          <div class="blurb-change-myEnrollVue">
            <div class="blurb-change-one-myEnrollVue" :class="change==1?'blurb-active-myEnrollVue':''" @click="changes(1)">
              我的投递
              <span class="blurb-nums-myEnrollVue" :class="change==1?'blurb-nums-active-myEnrollVue':''">{{ detailCount.signCount }}</span>
            </div>
            <div class="blurb-change-one-myEnrollVue" :class="change==2?'blurb-active-myEnrollVue':''" @click="changes(2)">
              我的收藏
              <span class="blurb-nums-myEnrollVue" :class="change==2?'blurb-nums-active-myEnrollVue':''">{{ detailCount.collectCount}}</span>
            </div>
            <div class="blurb-change-one-myEnrollVue" :class="change==3?'blurb-active-myEnrollVue':''" @click="changes(3)">
              查看我的
              <span class="blurb-nums-myEnrollVue" :class="change==3?'blurb-nums-active-myEnrollVue':''">{{ detailCount.viewCount}}</span>
            </div>
          </div>
          <!-- 原版修改2023-4-23-->
          <div v-if="change==1" class="enterpriseDetails-jobboxs" style="margin-bottom: 22px;" v-for="(item,index) in list" :key="index"  @click="jobDetails(item.id)">
            <div style="margin: 0 24px;padding: 16px 0 24px 0;border-bottom: 1px dashed #D9D9D9">
              <div class="enterpriseDetails-jobboxs-name">
                <div class="enterpriseDetails-jobboxs-name-l1">{{item.name}}</div>
                <div class="enterpriseDetails-jobboxs-name-l2">【{{item.address2}}】</div>
                <div class="enterpriseDetails-jobboxs-names">
<!--                  <img :src="item.companyInfo[0].logo" alt="">-->
                  <img v-if="item.companyInfo[0].logo!==''" :src="item.companyInfo[0].logo" alt="">
                  <img v-if="item.companyInfo[0].logo===''" src="../../assets/ping.png" alt="">
                  <div>{{item.companyInfo[0].name}}</div>
                </div>
              </div>
              <div class="enterpriseDetails-jobboxs-com" style="height: 26px;line-height: 26px;">
<!--                <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}-{{item.salaryEnd}}/月</div>
                <div v-if="item.salary==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salaryEnd}}元以下</div>
                <div v-if="item.salaryEnd==undefined&&item.salary!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}元以上</div>
                <div v-if="item.isSalary==2" class="enterpriseDetails-jobboxs-wages">面议</div>-->
                <div v-if="item.salaryName!==undefined&&item.salaryName!==null" class="enterpriseDetails-jobboxs-wages">{{item.salaryName}}</div>
                <div class="enterpriseDetails-jobboxs-educational">{{ item.eduName }}</div>
                <div class="enterpriseDetails-jobboxs-years">{{ item.workName }}</div>
                <div class="enterpriseDetails-jobboxs-label">
                  <div style="max-width: 56px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].nature}}</div>
                  <div style="max-width: 96px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].trade}}</div>
                  <div style="max-width: 86px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].scale}}</div>
                </div>
              </div>
            </div>

            <div class="enterpriseDetails-jobboxs-demand">
              <div class="enterpriseDetails-jobboxs-demands">
                <div v-for="(items, indexs) in list[index].tagList" :key="indexs" v-if="indexs<5">{{items.title}}</div>
              </div>
              <div style="float: right;width: 270px;">
                <div v-if="change==1" style="font-size: 12px;color: #979797;text-align: right;margin-right: 24px;line-height: 22px">投递时间：{{item.createTime}}</div>
              </div>
            </div>
          </div>
          <el-pagination v-if="change==1" :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          <!-- 原版修改2023-4-23-->
          <!-- 原版修改2023-4-23-->
          <div v-if="change==2" class="enterpriseDetails-jobboxs" style="margin-bottom: 22px;" v-for="(item,index) in listTwo" :key="index"  @click="jobDetails(item.id)">
            <div style="margin: 0 24px;padding: 16px 0 24px 0;border-bottom: 1px dashed #D9D9D9">
              <div class="enterpriseDetails-jobboxs-name">
                <div class="enterpriseDetails-jobboxs-name-l1">{{item.name}}</div>
                <div class="enterpriseDetails-jobboxs-name-l2">【{{item.address2}}】</div>
                <div class="enterpriseDetails-jobboxs-names">
<!--                  <img :src="item.companyInfo[0].logo" alt="">-->
                  <img v-if="item.companyInfo[0].logo!==''" :src="item.companyInfo[0].logo" alt="">
                  <img v-if="item.companyInfo[0].logo===''" src="../../assets/ping.png" alt="">
                  <div>{{item.companyInfo[0].name}}</div>
                </div>
              </div>
              <div class="enterpriseDetails-jobboxs-com" style="height: 26px;line-height: 26px;">
<!--                <div v-if="item.salary!==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}-{{item.salaryEnd}}/月</div>
                <div v-if="item.salary==undefined&&item.salaryEnd!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salaryEnd}}元以下</div>
                <div v-if="item.salaryEnd==undefined&&item.salary!==undefined" class="enterpriseDetails-jobboxs-wages">{{item.salary}}元以上</div>
                <div v-if="item.isSalary==2" class="enterpriseDetails-jobboxs-wages">面议</div>-->
                <div v-if="item.salaryName!==undefined&&item.salaryName!==null" class="enterpriseDetails-jobboxs-wages">{{item.salaryName}}</div>
                <div class="enterpriseDetails-jobboxs-educational">{{ item.eduName }}</div>
                <div class="enterpriseDetails-jobboxs-years">{{ item.workName }}</div>
                <div class="enterpriseDetails-jobboxs-label">
                  <div style="max-width: 56px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].nature}}</div>
                  <div style="max-width: 96px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].trade}}</div>
                  <div style="max-width: 86px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.companyInfo[0].scale}}</div>
                </div>
              </div>
            </div>

            <div class="enterpriseDetails-jobboxs-demand">
              <div class="enterpriseDetails-jobboxs-demands">
                <div v-for="(items, indexs) in listTwo[index].tagList" :key="indexs" v-if="indexs<5">{{items.title}}</div>
              </div>
              <div style="float: right;width: 270px;">
                <div v-if="change==2" style="font-size: 12px;color: #979797;text-align: right;margin-right: 24px;line-height: 22px">收藏时间：{{item.createTime}}</div>
              </div>
            </div>
          </div>
          <!-- 原版修改2023-4-23-->
          <el-pagination v-if="change==2" :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNumTwo" @size-change="handleSizeChangeTwo" @current-change="handleCurrentChangeTwo" />
          <!-- 2024.2.27-->
          <div v-if="change==3" class="enterpriseDetails-jobboxs" style="margin-bottom: 22px;" v-for="(item,index) in listThree" :key="index"  @click="jobCompanys(item.id)">
            <div style="margin: 0 24px;padding: 16px 0 24px 0;border-bottom: 1px dashed #D9D9D9">
              <div class="enterpriseDetails-jobboxs-name">
                <div class="enterpriseDetails-jobboxs-names_lookMe">
                  <img v-if="item.logoUrl!==''" :src="item.logoUrl" alt="">
                  <img v-if="item.logoUrl===''" src="../../assets/ping.png" alt="">
                  <div>{{item.name}}</div>
                </div>
              </div>
              <div class="enterpriseDetails-jobboxs-com" style="height: 26px;line-height: 26px;">
                <div class="enterpriseDetails-jobboxs-label_lookMe">
                  <div style="max-width: 56px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.nature}}</div>
                  <div style="max-width: 96px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.trade}}</div>
                  <div style="max-width: 86px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{item.cale}}</div>
                </div>
                <div class="enterpriseDetails-jobboxs-label" style="width: 10%;" >
                  <div style="font-size: 18px;font-size: 16px;color:#0091FF">查看</div>
                </div>
              </div>
            </div>

            <div class="enterpriseDetails-jobboxs-demand">
              <div class="enterpriseDetails-jobboxs-demands">
                <div v-for="(items, indexs) in listThree[index].tagList" :key="indexs" v-if="indexs<5">{{items.title}}</div>
              </div>
              <div style="float: right;width: 270px;">
                <div v-if="change==3" style="font-size: 12px;color: #979797;text-align: right;margin-right: 24px;line-height: 22px">查看时间：{{item.updateTime}}</div>
              </div>
            </div>
          </div>
          <!-- 原版修改2023-4-23-->
          <el-pagination v-if="change==3" :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNumThree" @size-change="handleSizeChangeThree" @current-change="handleCurrentChangeThree" />
        </div>
      </div>
      <!-- 个人信息 -->
      <div class="personalCore-right-myEnrollVue">
        <div class="personalCore-right-info-myEnrollVue">
          <img :src="userInfo.userPhoto" />
          <div>
            <div style="font-weight: bold">{{userInfo.userName}}</div>
            <div style="margin-top: 13px;font-size: 16px;color: #3D3D3D">
              <span v-if="userInfo.age !== '' && userInfo.age !== undefined">{{ userInfo.age }}岁</span>
              <span v-if="userInfo.age !== '' && userInfo.age !== undefined && userInfo.edu !== '' && userInfo.edu !== undefined">|</span>
              <span v-if="userInfo.edu">{{ userInfo.edu }}</span>
              <span v-if="userInfo.edu !== '' && userInfo.edu !== undefined && userInfo.condition !== '' && userInfo.condition !== undefined">|</span>
              <span v-if="userInfo.condition">{{ userInfo.condition }}</span>
<!--              {{ userInfo.age }}岁 | {{ userInfo.edu }} | {{ userInfo.condition }}-->
            </div>
          </div>
        </div>
        <div class="personalCore-right-box">
          <div style="display: flex;padding: 24px 31px 20px;">
            <div class="personalCore-right-boxs-myEnrollVue" @click="resume()" style="margin-right: 24px;">
              <img src="../../assets/personalCore-icon4.png" />
              <div>个人简历</div>
            </div>
<!--            <div class="personalCore-right-boxs-myEnrollVue" @click="enroll()">-->
              <div class="personalCore-right-boxs-myEnrollVue" @click="myDelivery()">
                <img src="../../assets/personalCore-icon2.png" />
                <div>我的投递</div>
              </div>
          </div>
          <div style="display: flex;padding: 0px 31px 35px;">
            <div class="personalCore-right-boxs-myEnrollVue" @click="go()" style="margin-right: 24px;">
              <img src="../../assets/personalCore-icon3.png"/>
              <div>我的收藏</div>
            </div>
            <div class="personalCore-right-boxs-myEnrollVue" @click="lookMe()">
              <img src="../../assets/personalCore-icon1.png"/>
              <div>查看我的</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      list: [],
      listTwo: [],
      listThree: [],
      userInfo: {},
      pageNum: 1,
      pageNumTwo: 1,
      pageNumThree: 1,
      pageSize: 30,
      pageSizeTwo: 30,
      pageSizeThree: 30,
      totalNum: 0,
      totalNumTwo: 0,
      totalNumThree: 0,
      change: 1,
      detailCount: {}
    }
  },
  beforeCreate () {
    var that = this
    that.$nextTick(() => {
      that.getData()
    })
    that.change = this.$route.query.change
    if (that.change === '2') {
      that.$nextTick(() => {
        that.changes(2)
      })
    } else if (that.change === '3') {
      that.$nextTick(() => {
        that.changes(3)
      })
    } else {
      that.$nextTick(() => {
        that.getList()
      })
    }
  },
  mounted () {

  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/userDetailCount`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.detailCount = res.data.data.detailCount
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    jobDetails (id) {
      this.$router.push({
        path: '/jobDetails',
        query: {
          id: id
        }
      })
    },
    jobCompanys (id) {
      this.$router.push({
        path: '/enterpriseDetails',
        query: {
          id: id
        }
      })
    },
    getList () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/sigUpList`,
        data: JSON.stringify({
          pageSize: that.pageSize,
          pageNum: that.pageNum
        })
      }).then(
        (res) => {
          that.list = res.data.data.list
          that.totalNum = res.data.data.totalPage
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getListTwo () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/collectionList`,
        data: JSON.stringify({
          pageSize: that.pageSizeTwo,
          pageNum: that.pageNumTwo
        })
      }).then(
        (res) => {
          that.listTwo = res.data.data.list
          that.totalNumTwo = res.data.data.totalPage
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getListThree () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `web/user/companyViewList`,
        data: JSON.stringify({
          pageSize: that.pageSizeThree,
          pageNum: that.pageNumThree
        })
      }).then(
        (res) => {
          that.listThree = res.data.data.list
          that.totalNumThree = res.data.data.totalPage
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    resume () {
      if (this.userInfo.isResume === false) {
        this.$router.push({ path: '/editResume' })
      } else {
        this.$router.push({ path: '/resume' })
      }
    },
    myDelivery () {
      var that = this
      that.change = 1
      that.getList()
    },
    go () {
      var that = this
      that.change = 2
      that.getListTwo()
      // this.$router.push({ path: '/myCollection' })
    },
    enroll () {
      // this.$router.push({ path: '/myEnroll' })
    },
    lookMe () { // 查看我的
      var that = this
      that.change = 3
      that.getListThree()
    },
    // 分页
    handleSizeChange (val) {
      this.pageNum = val
      this.getList()
    },
    handleSizeChangeTwo (val) {
      this.pageNumTwo = val
      this.getListTwo()
    },
    handleSizeChangeThree (val) {
      this.pageNumThree = val
      this.getListThree()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getList()
    },
    handleCurrentChangeTwo (val) {
      this.pageNumTwo = val
      this.getListTwo()
    },
    handleCurrentChangeThree (val) {
      this.pageNumThree = val
      this.getListThree()
    },
    changes (e) {
      this.change = e
      if (e === 1) {
        this.getList()
      } else if (e === 2) {
        this.getListTwo()
      } else if (e === 3) {
        this.getListThree()
      }
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
.personalCore-box{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 27px;
}
.personalCore-left-myEnrollVue{
  width: 860px;
  float: left;
  margin-right: 32px;
}
.personalCore-left-title{
  color: #0C0C0C;
  font-size: 20px;
  font-weight: 550;
  margin-bottom: 20px;
}
.personalCore-left-list{
  float: left;
}
.personalCore-joblist{
  width: 788px;
  margin-right: 9px;
  margin-bottom: 16px;
  cursor: pointer;
}
.enterpriseDetails-jobboxs{
  width: 860px;
  /*height: 122px;*/
  height: 153px;
  background-color: #ffff;
  border-radius: 5px;
  cursor: pointer;
}
.enterpriseDetails-jobboxs-name{
  height: 26px;line-height: 26px;margin-bottom: 16px
}
.enterpriseDetails-jobboxs-name-l1{
  float: left;font-size: 18px;font-weight: bold;margin-right: 14px;
}
.enterpriseDetails-jobboxs-name-l2{
  float: left;font-size: 14px;
}
.enterpriseDetails-jobboxs-names{
  float: right;width: 270px;
}
.enterpriseDetails-jobboxs-names img{
  float: left;
  width: 18px;
  height: 15px;
  margin-top: 4px;
  margin-right: 5px;
}
.enterpriseDetails-jobboxs-names div{
  /*float: left;*/
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.enterpriseDetails-jobboxs-names_lookMe{
  width: 100%;
}
.enterpriseDetails-jobboxs-names_lookMe img{
  float: left;
  width: 18px;
  height: 18px;
  margin-top: 3.5px;
  margin-right: 5px;
}
.enterpriseDetails-jobboxs-names_lookMe div{
  /*float: left;*/
  font-size: 18px;
}
.enterpriseDetails-jobboxs-com{
  overflow: hidden;
}
.enterpriseDetails-jobboxs-wages{
  margin-right: 31px;color: #FF8C41;font-size: 18px;font-weight: 600;float: left;
}
.enterpriseDetails-jobboxs-educational,.enterpriseDetails-jobboxs-years{
  float: left;font-size: 14px;color: #818181;margin-right: 12px;
}
.enterpriseDetails-jobboxs-label{
  float: right;width: 270px;
}
.enterpriseDetails-jobboxs-label div{
  float: left;
  font-size: 14px;
  color: #818181;
  margin-right: 12px;
}
.enterpriseDetails-jobboxs-label div:last-child{
  margin-right: 0;
}
.enterpriseDetails-jobboxs-label_lookMe{
  width: 100%;
}
.enterpriseDetails-jobboxs-label_lookMe div{
  float: left;
  font-size: 14px;
  color: #818181;
  margin-right: 12px;
}
.enterpriseDetails-jobboxs-label_lookMe div:last-child{
  margin-right: 0;
}
.enterpriseDetails-jobboxs-demand{
  overflow: hidden;
  margin-bottom: 12px;
  margin-top: 10px;
}
.enterpriseDetails-jobboxs-demands{
  float: left;
  overflow: hidden;
  margin-left: 24px;
}
.enterpriseDetails-jobboxs-demands div{
  float: left;
  padding: 2px 20px;
  border: 1px solid #0091FF;
  border-radius: 5px;
  font-size: 12px;
  margin-right: 16px;
  color: #027FFE;
}
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: center;
  margin-bottom: 28px;
}
.personalCore-right-myEnrollVue{
  width: 307px;
  float: left;
  height: 421px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 16px;
}
.personalCore-right-info-myEnrollVue{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCore-right-info-myEnrollVue img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 30px;
  border-radius: 50%;
}
.personalCore-right-info-myEnrollVue div{
  /*float: left;*/
  margin-top: 34px;
  font-size: 18px;
}
.personalCore-right-box{
  width: 100%;
}
.personalCore-right-boxs-myEnrollVue{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.personalCore-right-boxs-myEnrollVue img{
  width: 100%;
  height: 100%;
}
.personalCore-right-boxs-myEnrollVue div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.blurb-change-myEnrollVue{
  /*background-color: #f9f9f9;*/
  overflow: hidden;
  border-bottom: 4px solid #587CF7;
  width: 860px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.blurb-change-one-myEnrollVue{
  width: 200px;
  height: 49px;
  line-height: 49px;
  text-align: center;
  float: left;
  background-color: #fff;
  color: #000;
  font-size: 18px;
  /*margin-top: 15px;*/
  cursor:pointer;
}
.blurb-active-myEnrollVue{
  background-color: #587CF7;
  color: #FFF;
}
.blurb-nums-myEnrollVue{
  width: 52px;
  height: 24px;
  line-height: 24px;
  border-radius: 8px;
  background: #EBF5FE;
  /* margin-top: 6px; */
  display: inline-block;
  color: #91AAFF;
  border: 1px solid #91AAFF;
  vertical-align: middle;
  margin-left: 12px;
  font-size: 14px;
}
.blurb-nums-active-myEnrollVue{
  background: #fff;
  color: #587CF7;
}
/*2023-5-4*/

</style>



// WEBPACK FOOTER //
// src/views/jobSeekers/myEnroll.vue